export enum DocType {
    BANK_STATEMENT = 'BANK_STATEMENT',
    ELECTRICITY_BILL = 'ELECTRICITY_BILL',
    WATER_BILL = 'WATER_BILL',
    GAS_BILL = 'GAS_BILL',
    LANDLINE_BILL = 'LANDLINE_BILL',
}
